// extracted by mini-css-extract-plugin
export default {"overlay":"overlay--n8yC89BSZh"};